import * as Auth from '../api';

// in src/authProvider.js
export default {
  // called when the user attempts to log in
  login: async ({ username, password }) => {
    // Storage.setItem('username', username);
    // accept all username/password combinations
    // return Promise.resolve();
    try {
      const { data } = await Auth.login({ username, password });
      const { token, user } = data;

      localStorage.setItem('viBBes_token', token);
      localStorage.setItem('username', username);
      localStorage.setItem('role', user.role);

      return Promise.resolve();
    } catch (e) {
      return Promise.reject();
    }
  },
  // called when the user clicks on the logout button
  logout: () => {
    localStorage.removeItem('viBBes_token');
    return Promise.resolve();
  },
  // called when the API returns an error
  checkError: ({ status }) => {
    if (status === 401 || status === 403) {
      localStorage.removeItem('username');
      return Promise.reject();
    }
    return Promise.resolve();
  },
  // called when the user navigates to a new location, to check for authentication
  checkAuth: async () => {
    try {
      await Auth.check();
      return Promise.resolve();
    } catch (e) {
      return Promise.reject();
    }
  },
  // called when the user navigates to a new location, to check for permissions / roles
  getPermissions: () => {
    const role = localStorage.getItem('role');
    return role ? Promise.resolve(role) : Promise.resolve('GUEST');
  }
};
